import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, vModelText as _vModelText, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d318d5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = {
  key: 0,
  class: "m-5 text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spin fa-spinner me-3" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Loading...")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "m-5 text-center"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-arrow-left fa-fw" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Back to overview")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "alert" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " All files of a selected type in the ZIP file will be extracted and uploaded using the Asset Bulk Import. Please upload the sample bulk import file here and configure the contents for each column. ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "File types", -1))
const _hoisted_14 = { class: "filetypeslist mb-5" }
const _hoisted_15 = { class: "form-check" }
const _hoisted_16 = ["id", "onUpdate:modelValue"]
const _hoisted_17 = ["for"]
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "extensions-list" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "Test mode", -1))
const _hoisted_21 = { class: "mb-5" }
const _hoisted_22 = { class: "form-check" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "testModeCheck"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Test Mode"),
  /*#__PURE__*/_createElementVNode("small", { class: "extensions-list" }, "By enabling test mode you can do some tests here. Enter the values for testing below, and you will see the results of each column directly.")
], -1))
const _hoisted_24 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_25 = { class: "table table-sm table-borderless" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Variable"),
    /*#__PURE__*/_createElementVNode("th", null, "Value"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = ["type", "onUpdate:modelValue"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "Import data", -1))
const _hoisted_30 = {
  type: "file",
  ref: "sampleFile"
}
const _hoisted_31 = { class: "table table-column table-borderless" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Column", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Value", -1))
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 0,
  class: "alert alert-danger d-block p-1 m-1"
}
const _hoisted_39 = { class: "d-flex flex-row-reverse" }
const _hoisted_40 = { class: "dropdown" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-light dropdown-toggle dropdown-toggle-gears",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, null, -1))
const _hoisted_42 = { class: "dropdown-menu" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 0,
  class: "dropdown me-2"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-light dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, null, -1))
const _hoisted_59 = { class: "dropdown-menu" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  key: 1,
  class: "dropdown me-2"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-light dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, null, -1))
const _hoisted_63 = { class: "dropdown-menu" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = {
  key: 2,
  class: "dropdown me-2"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-light dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, null, -1))
const _hoisted_67 = { class: "dropdown-menu" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  key: 0,
  class: "create-custom-field-values-row"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_71 = ["onUpdate:modelValue"]
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" Create non-existing values automatically ")
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_74 = { key: 3 }
const _hoisted_75 = { class: "nav nav-tabs" }
const _hoisted_76 = { class: "nav-item" }
const _hoisted_77 = { class: "nav-item" }
const _hoisted_78 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_79 = {
  key: 0,
  class: "alert alert-info d-flex align-items-center justify-content-center"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spinner fa-spin fa-2x" }, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-3 m-0" }, "Please wait...", -1))
const _hoisted_82 = [
  _hoisted_80,
  _hoisted_81
]
const _hoisted_83 = {
  key: 1,
  class: "alert alert-info"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The ZIP asset is now being downloaded and extracted. A CSV file will be created when done.", -1))
const _hoisted_85 = {
  key: 2,
  class: "alert alert-info"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The CSV file will now be uploaded to Sprinklr.", -1))
const _hoisted_87 = {
  key: 3,
  class: "alert alert-info"
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The zip file is reset. You can now create a CSV file again.", -1))
const _hoisted_89 = { key: 4 }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-sync fa-fw" }, null, -1))
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = { class: "table table-recent-zips table-borderless" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Filename"),
    /*#__PURE__*/_createElementVNode("th", null, "Asset ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Size"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Import CSV"),
    /*#__PURE__*/_createElementVNode("th", null, "Upload to Sprinklr"),
    /*#__PURE__*/_createElementVNode("th", null, "Reset")
  ])
], -1))
const _hoisted_94 = ["value", "id"]
const _hoisted_95 = ["for"]
const _hoisted_96 = { key: 0 }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = ["href"]
const _hoisted_100 = ["href"]
const _hoisted_101 = ["onClick"]
const _hoisted_102 = ["onClick"]
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Not active", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_107 = { class: "d-flex flex-row align-items-center" }
const _hoisted_108 = ["value"]
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-file-archive fa-fw" }, null, -1))
const _hoisted_110 = /*#__PURE__*/_createTextVNode(" Extract ")
const _hoisted_111 = [
  _hoisted_109,
  _hoisted_110
]
const _hoisted_112 = {
  key: 1,
  class: "tab-content"
}
const _hoisted_113 = { class: "table table-ruleset table-borderless" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Ruleset"),
    /*#__PURE__*/_createElementVNode("th", null, "Client"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1))
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { key: 1 }
const _hoisted_117 = ["onClick"]
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-pencil-alt fa-fw" }, null, -1))
const _hoisted_119 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_120 = [
  _hoisted_118,
  _hoisted_119
]
const _hoisted_121 = ["onClick"]
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-pencil-alt fa-fw" }, null, -1))
const _hoisted_123 = /*#__PURE__*/_createTextVNode(" Duplicate ")
const _hoisted_124 = [
  _hoisted_122,
  _hoisted_123
]
const _hoisted_125 = ["onClick"]
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-trash fa-fw" }, null, -1))
const _hoisted_127 = /*#__PURE__*/_createTextVNode(" Remove ")
const _hoisted_128 = [
  _hoisted_126,
  _hoisted_127
]
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-plus fa-fw" }, null, -1))
const _hoisted_130 = /*#__PURE__*/_createTextVNode(" Add ruleset")
const _hoisted_131 = [
  _hoisted_129,
  _hoisted_130
]
const _hoisted_132 = { class: "row mb-3" }
const _hoisted_133 = { class: "col-md-6" }
const _hoisted_134 = { class: "form-group mb-3" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "ruleset-name" }, "Name:", -1))
const _hoisted_136 = { class: "form-group mb-3" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "client-id" }, "Client:", -1))
const _hoisted_138 = ["value"]
const _hoisted_139 = { class: "row mb-3" }
const _hoisted_140 = { class: "col-md-6" }
const _hoisted_141 = { class: "form-group mb-3" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "ruleset-name" }, "Name:", -1))
const _hoisted_143 = { class: "form-group mb-3" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "client-id" }, "Client:", -1))
const _hoisted_145 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.ready)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_ctx.ready && _ctx.clientFetchError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Please reauthenticate App"))
        : (_ctx.editRuleSet)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("h2", null, [
                _createElementVNode("span", null, "Edit unzip rules: " + _toDisplayString(_ctx.editRuleSet.name), 1),
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeRuleSet && _ctx.closeRuleSet(...args)), ["prevent"]))
                }, _hoisted_10)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _createElementVNode("ul", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filetypesList, (fileType, idx) => {
                    return (_openBlock(), _createElementBlock("li", { key: idx }, [
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          checked: "checked",
                          value: "",
                          id: fileType.name,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.editRuleSet.filetypes[fileType.name]) = $event)
                        }, null, 8, _hoisted_16), [
                          [_vModelCheckbox, _ctx.editRuleSet.filetypes[fileType.name]]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: fileType.name
                        }, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(fileType.label), 1),
                          _createElementVNode("small", _hoisted_19, _toDisplayString(fileType.extensions.join(', ')), 1)
                        ], 8, _hoisted_17)
                      ])
                    ]))
                  }), 128))
                ]),
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: "",
                      id: "testModeCheck",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.testMode) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.testMode]
                    ]),
                    _hoisted_23
                  ]),
                  (_ctx.testMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("table", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testModeFields, (field, fieldIdx) => {
                              return (_openBlock(), _createElementBlock("tr", { key: fieldIdx }, [
                                _createElementVNode("td", null, _toDisplayString(field.label), 1),
                                _createElementVNode("td", null, [
                                  (field.type == 'readonly' && typeof field.value == 'function')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(field.value(_ctx.testModeFields[0].value)), 1))
                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 1,
                                        type: field.type,
                                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                        class: "form-control"
                                      }, null, 8, _hoisted_28)), [
                                        [_vModelDynamic, field.value]
                                      ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.runTest && _ctx.runTest(...args)))
                        }, "Run test")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_29,
                _createElementVNode("input", _hoisted_30, null, 512),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.readSampleFile && _ctx.readSampleFile(...args)))
                }, "Read columns"),
                _createElementVNode("table", _hoisted_31, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_32,
                      _hoisted_33,
                      (_ctx.testMode)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_34, "Test result"))
                        : _createCommentVNode("", true),
                      _hoisted_35
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editRuleSet.columns, (column, columnName) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: columnName }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", {
                            class: _normalizeClass({
                                        required:
                                            column.name.indexOf('Partner CF:') === 0 &&
                                            _ctx.customFieldRequired(column.name.substring(11)),
                                    })
                          }, _toDisplayString(column.name), 3),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("textarea", {
                              rows: "1",
                              "onUpdate:modelValue": ($event: any) => ((column.value) = $event),
                              class: "form-control"
                            }, null, 8, _hoisted_36), [
                              [_vModelText, column.value]
                            ])
                          ]),
                          (_ctx.testMode)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_37, [
                                (_ctx.testResults[columnName] && _ctx.testResults[columnName].indexOf('ERROR: ') === 0)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_38, _toDisplayString(_ctx.testResults[columnName]), 1))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.testResults[columnName]), 1)
                                    ], 64))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _hoisted_41,
                                _createElementVNode("ul", _hoisted_42, [
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (column.value = '{{ mediapath }}'), ["prevent"])
                                    }, "Media path", 8, _hoisted_43)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (column.value = '{{ filename }}'), ["prevent"])
                                    }, "Filename from zip", 8, _hoisted_44)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (
                                                            column.value = '{{ basename | split(\'_\', 2) }}'
                                                        ), ["prevent"])
                                    }, "Filename part", 8, _hoisted_45)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (column.value = '{{ fileextension }}'), ["prevent"])
                                    }, "File extension from zip", 8, _hoisted_46)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (column.value = '{{ filepath }}'), ["prevent"])
                                    }, "Path from zip", 8, _hoisted_47)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (column.value = '{{ filepath | splitpath(2) }}'), ["prevent"])
                                    }, "Part of path", 8, _hoisted_48)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (column.value = '{{ filesize }}'), ["prevent"])
                                    }, "Filesize", 8, _hoisted_49)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (column.value = '{{ assettype }}'), ["prevent"])
                                    }, "Auto detect asset type", 8, _hoisted_50)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (
                                                            column.value =
                                                                '{{ now | dateformat(\'MM/DD/YYYY hh:mm:ss a G\\\\MTZ\') }}'
                                                        ), ["prevent"])
                                    }, "Current date", 8, _hoisted_51)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (column.value = '{{ zip_filename }}'), ["prevent"])
                                    }, "ZIP Asset file name", 8, _hoisted_52)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (column.value = '{{ zip_campaign }}'), ["prevent"])
                                    }, "ZIP Asset Campaign", 8, _hoisted_53)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (
                                                            column.value =
                                                                '{{ zip_campaign_start | dateformat(\'MM/DD/YYYY hh:mm:ss a G\\\\MTZ\') }}'
                                                        ), ["prevent"])
                                    }, "ZIP Asset Campaign Start", 8, _hoisted_54)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (
                                                            column.value =
                                                                '{{ zip_campaign_end | dateformat(\'MM/DD/YYYY hh:mm:ss a G\\\\MTZ\') }}'
                                                        ), ["prevent"])
                                    }, "ZIP Asset Campaign End", 8, _hoisted_55)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (column.value = '{{ custom[\'Custom Field Name\'] }}'), ["prevent"])
                                    }, "ZIP Asset Custom Field", 8, _hoisted_56)
                                  ])
                                ])
                              ]),
                              (column.name.indexOf('Partner CF:') === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    _hoisted_58,
                                    _createElementVNode("ul", _hoisted_59, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customFieldOptions(
                                                        column.name.substring(11),
                                                    ), (option, idx) => {
                                        return (_openBlock(), _createElementBlock("li", { key: idx }, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (column.value = option.label), ["prevent"])
                                          }, _toDisplayString(option.label), 9, _hoisted_60)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (column.name.indexOf('Campaigns') === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                    _hoisted_62,
                                    _createElementVNode("ul", _hoisted_63, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignFieldOptions, (option, idx) => {
                                        return (_openBlock(), _createElementBlock("li", { key: idx }, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (column.value = option.value), ["prevent"])
                                          }, _toDisplayString(option.label), 9, _hoisted_64)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (
                                                column.name.indexOf('Sub Campaigns') === 0 &&
                                                _ctx.subCampaignFieldOptions.length
                                            )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                    _hoisted_66,
                                    _createElementVNode("ul", _hoisted_67, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subCampaignFieldOptions, (option, idx) => {
                                        return (_openBlock(), _createElementBlock("li", { key: idx }, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (column.value = option.value), ["prevent"])
                                          }, _toDisplayString(option.label), 9, _hoisted_68)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        (column.name.indexOf('Partner CF:') === 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_69, [
                              _hoisted_70,
                              _createElementVNode("td", null, [
                                _createElementVNode("label", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event: any) => ((column.createCustomFieldValues) = $event),
                                    "true-value": true,
                                    "false-value": false
                                  }, null, 8, _hoisted_71), [
                                    [_vModelCheckbox, column.createCustomFieldValues]
                                  ]),
                                  _hoisted_72
                                ])
                              ]),
                              _hoisted_73
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_74, [
              _createElementVNode("ul", _hoisted_75, [
                _createElementVNode("li", _hoisted_76, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { active: _ctx.tab === 'extract' }]),
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.tab = 'extract'), ["prevent"])),
                    href: "#"
                  }, "Extract ZIP asset", 2)
                ]),
                _createElementVNode("li", _hoisted_77, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { active: _ctx.tab === 'rulesets' }]),
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.tab = 'rulesets'), ["prevent"])),
                    href: "#"
                  }, "Define unzip rules", 2)
                ])
              ]),
              (_ctx.tab === 'extract')
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                    (_ctx.working)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, _hoisted_82))
                      : (_ctx.extractAssetDone)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            _hoisted_84,
                            _createElementVNode("button", {
                              class: "btn btn-secondary",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.extractAssetDone = false))
                            }, "Extract another file")
                          ]))
                        : (_ctx.uploadCsvDone)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                              _hoisted_86,
                              _createElementVNode("button", {
                                class: "btn btn-secondary",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.uploadCsvDone = false))
                              }, "Extract another file")
                            ]))
                          : (_ctx.resetImportDone)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                _hoisted_88,
                                _createElementVNode("button", {
                                  class: "btn btn-secondary",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resetImportDone = false))
                                }, "Go back")
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                _createElementVNode("button", {
                                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.refreshRecentFiles && _ctx.refreshRecentFiles(...args))),
                                  class: "float-end btn btn-light"
                                }, _hoisted_91),
                                _createElementVNode("table", _hoisted_92, [
                                  _hoisted_93,
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentZipAssets, (zipAsset, zipAssetIdx) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: zipAssetIdx }, [
                                        _createElementVNode("td", null, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "radio",
                                            name: "extract-zip",
                                            value: zipAsset.id + ',' + zipAsset.ownerClientId,
                                            id: 'extract-zip' + zipAsset.id,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.extractAssetId) = $event))
                                          }, null, 8, _hoisted_94), [
                                            [_vModelRadio, _ctx.extractAssetId]
                                          ])
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("label", {
                                            for: 'extract-zip' + zipAsset.id
                                          }, _toDisplayString(zipAsset.name), 9, _hoisted_95)
                                        ]),
                                        _createElementVNode("td", null, _toDisplayString(zipAsset.id), 1),
                                        _createElementVNode("td", null, [
                                          (zipAsset.digitalAsset && zipAsset.digitalAsset.sizeInBytes)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString(_ctx.formatBytes(zipAsset.digitalAsset.sizeInBytes)), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        (_ctx.activeImports[zipAsset.id])
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (_ctx.activeImports[zipAsset.id].status)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_97, _toDisplayString(_ctx.activeImports[zipAsset.id].status), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_98, "Import active")),
                                              _createElementVNode("td", null, [
                                                (_ctx.activeImports[zipAsset.id] && _ctx.activeImports[zipAsset.id].csvUrl && _ctx.activeImports[zipAsset.id].csvUrl.length)
                                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.activeImports[zipAsset.id].csvUrl, (csvUrl, idx) => {
                                                      return (_openBlock(), _createElementBlock("a", {
                                                        key: idx,
                                                        href: csvUrl,
                                                        target: "_blank",
                                                        class: "btn btn-sm btn-darklight me-2",
                                                        title: "Download CSV file"
                                                      }, _toDisplayString(idx + 1), 9, _hoisted_99))
                                                    }), 128))
                                                  : (_ctx.activeImports[zipAsset.id] && _ctx.activeImports[zipAsset.id].csvUrl)
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 1,
                                                        href: _ctx.activeImports[zipAsset.id].csvUrl,
                                                        target: "_blank"
                                                      }, "CSV", 8, _hoisted_100))
                                                    : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("a", {
                                                  href: "#",
                                                  onClick: _withModifiers(($event: any) => (_ctx.uploadCsv(zipAsset.id, zipAsset.ownerClientId)), ["stop","prevent"]),
                                                  target: "_blank"
                                                }, "upload", 8, _hoisted_101)
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("a", {
                                                  href: "#",
                                                  onClick: _withModifiers(($event: any) => (_ctx.resetImport(zipAsset.id, zipAsset.ownerClientId)), ["stop","prevent"]),
                                                  target: "_blank"
                                                }, "reset", 8, _hoisted_102)
                                              ])
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _hoisted_103,
                                              _hoisted_104,
                                              _hoisted_105,
                                              _hoisted_106
                                            ], 64))
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_107, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.extractRuleSet) = $event)),
                                    class: "form-select w-25 me-2"
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rulesets, (ruleset, rulesetIdx) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: rulesetIdx,
                                        value: ruleset.name
                                      }, _toDisplayString(ruleset.name), 9, _hoisted_108))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _ctx.extractRuleSet]
                                  ]),
                                  _createElementVNode("button", {
                                    class: "btn btn-primary",
                                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.extractAsset && _ctx.extractAsset(...args)))
                                  }, _hoisted_111)
                                ])
                              ]))
                  ]))
                : (_ctx.tab === 'rulesets')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                      _createElementVNode("table", _hoisted_113, [
                        _hoisted_114,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rulesets, (ruleset, rulesetIdx) => {
                            return (_openBlock(), _createElementBlock("tr", { key: rulesetIdx }, [
                              _createElementVNode("td", null, _toDisplayString(ruleset.name), 1),
                              (_ctx.clients[ruleset.clientId])
                                ? (_openBlock(), _createElementBlock("td", _hoisted_115, _toDisplayString(_ctx.clients[ruleset.clientId].clientName), 1))
                                : (_openBlock(), _createElementBlock("td", _hoisted_116, "Unknown client")),
                              _createElementVNode("td", null, [
                                _createElementVNode("button", {
                                  class: "btn btn-outline-primary me-2",
                                  onClick: ($event: any) => (_ctx.editRuleSet = ruleset)
                                }, _hoisted_120, 8, _hoisted_117),
                                _createElementVNode("button", {
                                  class: "btn btn-outline-primary",
                                  onClick: ($event: any) => (_ctx.duplicateRuleSet = _ctx.cloneDeep(ruleset))
                                }, _hoisted_124, 8, _hoisted_121),
                                _createElementVNode("button", {
                                  class: "btn btn-outline-danger",
                                  onClick: ($event: any) => (_ctx.rulesets.splice(rulesetIdx, 1))
                                }, _hoisted_128, 8, _hoisted_125)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onAddRuleSet && _ctx.onAddRuleSet(...args)))
                      }, _hoisted_131)
                    ]))
                  : _createCommentVNode("", true)
            ])),
    (_ctx.addRuleSet)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 4,
          title: "Add RuleSet",
          onConfirm: _ctx.doAddRuleSet,
          onCancel: _cache[16] || (_cache[16] = ($event: any) => (_ctx.addRuleSet = false)),
          "show-footer": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_132, [
              _createElementVNode("div", _hoisted_133, [
                _createElementVNode("form", null, [
                  _createElementVNode("div", _hoisted_134, [
                    _hoisted_135,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "ruleset-name",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newRuleSetName) = $event)),
                      placeholder: "Enter name"
                    }, null, 512), [
                      [_vModelText, _ctx.newRuleSetName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_136, [
                    _hoisted_137,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control form-select",
                      id: "client-id",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newRuleSetClientId) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clients, (client, clientId) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: clientId,
                          value: clientId
                        }, _toDisplayString(client.clientName), 9, _hoisted_138))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.newRuleSetClientId]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.duplicateRuleSet)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 5,
          title: "Duplicate RuleSet",
          onConfirm: _ctx.doDuplicateRuleSet,
          onCancel: _cache[19] || (_cache[19] = ($event: any) => (_ctx.duplicateRuleSet = false)),
          "show-footer": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_139, [
              _createElementVNode("div", _hoisted_140, [
                _createElementVNode("form", null, [
                  _createElementVNode("div", _hoisted_141, [
                    _hoisted_142,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "ruleset-name",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.duplicateRuleSet.name) = $event)),
                      placeholder: "Enter name"
                    }, null, 512), [
                      [_vModelText, _ctx.duplicateRuleSet.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_143, [
                    _hoisted_144,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control form-select",
                      id: "client-id",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.duplicateRuleSet.clientId) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clients, (client, clientId) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: clientId,
                          value: clientId
                        }, _toDisplayString(client.clientName), 9, _hoisted_145))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.duplicateRuleSet.clientId]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onConfirm"]))
      : _createCommentVNode("", true)
  ]))
}